<div class="modal-header ">
    <h4 class="modal-title">Raise Complaint</h4>
    <img src="assets/media/icons/png/check.png" class="modalClose" (click)="closemodal()">
</div>
<div class="modal-body">
    <div class="row formparentRow">
        <div class="col-sm-12 col-md-12">
            <label class="control-label centeredlabel">{{'CYRIX.NOTE' | translate}}</label>
        </div>
        <div class="col-sm-12 col-md-12">
            <textarea type="text" id="note" class='form-control' name="note" placeholder="{{'CUSTOMER.ENTER'|translate}} Note"
                rows="5" aria-required="true" [(ngModel)]="note"></textarea>
        </div>
    </div>
    <div class="col-md-12">
        <button type="button" [ngClass]="{'kt-spinner kt-spinner--right kt-spinner--md kt-spinner--info': loadingAdd}"
            class="btn btnFill pull-right mb-3"  (click)="raiseticket(ticket_success)">{{'BUTTON.SUBMIT' | translate}}</button>
    </div>
</div>

<ng-template #ticket_success let-c="close" let-d="dismiss">
    <div class="SucessPopup">
        <div class="modal-body">
            <img src="assets/media/icons/png/check.png" class="modalClose" (click)="route()">
            <div class="SucessPopupMsg">
                <img src="assets/media/icons/png/Done.png">
                <h4>{{successraise_message}}</h4>
            </div>
        </div>
    </div>
</ng-template>